import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
} from "@mui/material";
import axios from "../../../utils/axiosInstance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUIDescription } from "../customerGroupDetails/AssigningCustomerGroupDevice";
export default function AddRegionForm({ open, onClose, onAddRegion, group }) {
  const [regionName, setRegionName] = useState("");
  const [groupName, setGroupName] = useState(group.name);
  const [regionDescription, setRegionDescription] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); // 🔹 Loading state

  // 🔹 Validation function
  const validateForm = () => {
    const newErrors = {};
    if (!regionName.trim()) newErrors.regionName = "Region Name is required";
    if (!groupName) newErrors.groupName = "Group Name is required";
    // if (!regionDescription.trim())
    //   newErrors.regionDescription = "Region Description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddRegion = async () => {
    if (!validateForm()) return;

    setLoading(true); // 🔹 Start loading
    try {
      const payload = {
        companyId: process.env.REACT_APP_COMPANY_ID,
        name: regionName,
        description: regionDescription,
        groupId: group.id,
        type: "geographical",
        UI_Description: `${getUIDescription()}\n Add Region`, 
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/regions/`,
        payload
      );

      if (onAddRegion) {
        onAddRegion(response.data);
      }
      
      console.log("✅ Region created:", response.data);
      toast.success("✅ Region created successfully!");

      onClose();
      resetForm();
    } catch (error) {
      console.error(
        "❌ Error creating region:",
        error.response?.data || error.message
      );
      toast.error(
        error.response?.data?.message || "❌ Failed to create region"
      );
    } finally {
      setLoading(false); // 🔹 Stop loading
    }
  };

  const handleFieldChange = (field, value, setter) => {
    setter(value);
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const resetForm = () => {
    setRegionName("");
    setRegionDescription("");
    setErrors({});
  };

  const handleCancel = () => {
    resetForm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Region</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Region Name"
            required
            value={regionName}
            onChange={(e) =>
              handleFieldChange("regionName", e.target.value, setRegionName)
            }
            fullWidth
            error={!!errors.regionName}
            helperText={errors.regionName}
            disabled={loading} // 🔹 Disable while loading
          />

          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Region Description"
            value={regionDescription}
            onChange={(e) =>
              handleFieldChange(
                "regionDescription",
                e.target.value,
                setRegionDescription
              )
            }
            fullWidth
            error={!!errors.regionDescription}
            helperText={errors.regionDescription}
            disabled={loading}
          />

          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Group Name"
            required
            disabled
            value={groupName}
            fullWidth
            error={!!errors.groupName}
            helperText={errors.groupName}
          />

          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Group Key"
            required
            disabled
            value={group.id}
            fullWidth
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel} color="error" disabled={loading}>
          Cancel
        </Button>
        <Button
          sx={{
            borderRadius: 0, // ✅ remove rounding
          }}
          onClick={handleAddRegion}
          variant="contained"
          color="primary"
          disabled={loading || !regionName || !groupName}
        >
          {loading ? (
            <>
              <CircularProgress size={22} color="inherit" sx={{ mr: 1 }} />
              Adding...
            </>
          ) : (
            "Add Region"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
